import axiosInstanceNew from "../lib/axiosinstanceNew";

const EHCModel = class {
  constructor() {
    this.staticData = [
      {
        id: 1,
        s_no: 1,
        student_name: "Rahul Sharma",
        parent_name: "Mr. Sharma",
        parent_mobile: "+91-9876543210",
        class: "Mathematics Grade 8",
        class_type: "COMBINED",
        educator_name: "Mrs. Priya Singh",
        educator_mobile: "+91-9876543211",
        invigilator_date_time: "2024-11-01 10:00 AM",
        discovery_call_status: "Completed",
        discovery_call_date: "2024-10-25",
        location: "Delhi",
        last_ehc_date: "2024-11-01",
        last_src_date: "2024-10-28",
        class_status: "Active",
        test_status: "Completed",
        ehc_manager_name: "Mr. Rajesh Kumar",
        ehc_manager_mobile: "+91-9876543212",
        class_remaining_percentage: 75,
        subject: "Mathematics",
        score: 85,
        total_marks: 100,
        test_date: "2024-11-01",
        created_at: "2024-10-25T10:00:00Z",
        updated_at: "2024-11-01T14:30:00Z",
      },
      {
        id: 2,
        s_no: 2,
        student_name: "Priya Patel",
        parent_name: "Mrs. Patel",
        parent_mobile: "+91-9876543213",
        class: "Science Grade 9",
        class_type: "SME",
        educator_name: "Mr. Amit Verma",
        educator_mobile: "+91-9876543214",
        invigilator_date_time: "2024-11-15 02:00 PM",
        discovery_call_status: "Scheduled",
        discovery_call_date: "2024-11-10",
        location: "Mumbai",
        last_ehc_date: "2024-11-08",
        last_src_date: "2024-11-05",
        class_status: "Active",
        test_status: "Pending",
        ehc_manager_name: "Mrs. Sunita Sharma",
        ehc_manager_mobile: "+91-9876543215",
        class_remaining_percentage: 60,
        subject: "Science",
        score: null,
        total_marks: 100,
        test_date: "2024-11-15",
        created_at: "2024-11-01T09:15:00Z",
        updated_at: "2024-11-01T09:15:00Z",
      },
      {
        id: 3,
        s_no: 3,
        student_name: "Amit Kumar",
        parent_name: "Mr. Kumar",
        parent_mobile: "+91-9876543216",
        class: "English Grade 7",
        class_type: "SEPARATE",
        educator_name: "Mrs. Rekha Gupta",
        educator_mobile: "+91-9876543217",
        invigilator_date_time: "2024-10-28 11:30 AM",
        discovery_call_status: "In Progress",
        discovery_call_date: "2024-10-20",
        location: "Bangalore",
        last_ehc_date: "2024-10-28",
        last_src_date: "2024-10-25",
        class_status: "Hold",
        test_status: "In Progress",
        ehc_manager_name: "Mr. Vikram Singh",
        ehc_manager_mobile: "+91-9876543218",
        class_remaining_percentage: 45,
        subject: "English",
        score: 72,
        total_marks: 100,
        test_date: "2024-10-28",
        created_at: "2024-10-20T11:45:00Z",
        updated_at: "2024-10-28T16:20:00Z",
      },
      {
        id: 4,
        s_no: 4,
        student_name: "Sneha Gupta",
        parent_name: "Mrs. Gupta",
        parent_mobile: "+91-9876543219",
        class: "Social Studies Grade 6",
        class_type: "COMBINED",
        educator_name: "Mr. Rohan Mehta",
        educator_mobile: "+91-9876543220",
        invigilator_date_time: "2024-10-20 09:15 AM",
        discovery_call_status: "Completed",
        discovery_call_date: "2024-10-15",
        location: "Chennai",
        last_ehc_date: "2024-10-20",
        last_src_date: "2024-10-18",
        class_status: "Completed",
        test_status: "Completed",
        ehc_manager_name: "Mrs. Anjali Desai",
        ehc_manager_mobile: "+91-9876543221",
        class_remaining_percentage: 100,
        subject: "Social Studies",
        score: 92,
        total_marks: 100,
        test_date: "2024-10-20",
        created_at: "2024-10-15T08:30:00Z",
        updated_at: "2024-10-20T13:45:00Z",
      },
      {
        id: 5,
        s_no: 5,
        student_name: "Vikram Singh",
        parent_name: "Mr. Singh",
        parent_mobile: "+91-9876543222",
        class: "Hindi Grade 5",
        class_type: "SME",
        educator_name: "Mrs. Pooja Jain",
        educator_mobile: "+91-9876543223",
        invigilator_date_time: null,
        discovery_call_status: "Not Scheduled",
        discovery_call_date: null,
        location: "Pune",
        last_ehc_date: "2024-10-01",
        last_src_date: "2024-09-28",
        class_status: "Discontinued",
        test_status: "Not Started",
        ehc_manager_name: "Mr. Sanjay Patel",
        ehc_manager_mobile: "+91-9876543224",
        class_remaining_percentage: 0,
        subject: "Hindi",
        score: null,
        total_marks: 100,
        test_date: null,
        created_at: "2024-09-15T12:00:00Z",
        updated_at: "2024-10-01T10:00:00Z",
      },
    ];
  }

  async List(status, teststatus, query = []) {
    // Return static data instead of API call
    return new Promise((resolve) => {
      setTimeout(() => {
        // Filter data based on status and teststatus if provided
        let filteredData = this.staticData;

        if (status && status !== "?class_status=All") {
          const statusValue = status.replace("?class_status=", "");
          filteredData = filteredData.filter(
            (item) => item.class_status === statusValue
          );
        }

        if (teststatus && teststatus !== "?test_status=All") {
          const testStatusValue = teststatus.replace("?test_status=", "");
          filteredData = filteredData.filter(
            (item) => item.test_status === testStatusValue
          );
        }

        resolve({
          data: filteredData,
          meta: {
            current_page: 1,
            per_page: 10,
            total_page: 1,
            total: filteredData.length,
          },
        });
      }, 500);
    });
  }
  async Listcount(status) {
    // Return count from static data
    return new Promise((resolve) => {
      setTimeout(() => {
        status = String(status || "");
        let count = 0;

        if (status === "?class_status=All") {
          count = this.staticData.length;
        } else if (status.includes("class_status=")) {
          const statusValue = status.replace("?class_status=", "");
          count = this.staticData.filter(
            (item) => item.class_status === statusValue
          ).length;
        } else if (status.includes("class_type=")) {
          const typeValue = status.replace("?class_type=", "");
          count = this.staticData.filter(
            (item) => item.class_type === typeValue
          ).length;
        }

        resolve({ count });
      }, 300);
    });
  }
  async create(data = []) {
    return await axiosInstanceNew.post(this.baseUrl, data);
  }
  async detail(id) {
    return (await axiosInstanceNew.get(`${this.baseUrl}/${id}`)).data;
  }
  async update(id, data = []) {
    return await axiosInstanceNew.put(`${this.baseUrl}/${id}`, data);
  }
  async delete(id) {
    return await axiosInstanceNew.delete(`${this.baseUrl}/${id}`);
  }
};

export default new EHCModel();
